import {RouteObject} from 'react-router-dom';
import {lazyAdminRoute} from '@common/admin/routes/lazy-admin-route';

export const appAdminRoutes: RouteObject[] = [
  {
    path: 'contact-messages',
    lazy: () => lazyAdminRoute('ContactInboxPage'),
  },
  {
    path: 'contact-messages/:messageId',
    lazy: () => lazyAdminRoute('ContactMessageDetailsPage'),
  },
];
